import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-lang',
  templateUrl: './product-lang.component.html',
  styleUrls: ['./product-lang.component.css']
})
export class ProductLangComponent implements OnInit {
    prodLangKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodLangKeyno = this.stateService.getStateParams()['prodlang_keyno'];
    }

    private async loadEdit() {
        if (!!this.prodLangKeyno) {
            this.edit = (await this.datatask.Post(1083, { prodlang_keyno: this.prodLangKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1084, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prodlang_keyno: string;
    prodlang_name: string;
    salesinfo: string;
    salesinfo2: string;
    salesinfo3: string;
    salesinfo4: string;
    language_name: string;
    prodlang_name_short: string;
}
